import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { YearProvider } from "@/context/YearContext";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Header } from "@/components/layout/Header";
import AuthCallback from "@/components/AuthCallback";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Budget from "@/pages/Budget";
import Closing from "@/pages/Closing";
import Funds from "@/pages/Funds";
import Settings from "@/pages/Settings";

function ProtectedLayout() {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F8F7F3]" data-testid="auth-loading">
        <p className="text-zinc-500 text-sm">Loading…</p>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return (
    <YearProvider>
      <Header />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/budget" element={<Budget />} />
          <Route path="/closing" element={<Closing />} />
          <Route path="/funds" element={<Funds />} />
          <Route path="/settings" element={user.role === "admin" ? <Settings /> : <Navigate to="/" replace />} />
        </Routes>
      </main>
    </YearProvider>
  );
}

function AppRouter() {
  const location = useLocation();
  // Synchronous check during render — session_id must be processed BEFORE any auth check
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/*" element={<ProtectedLayout />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App bg-background min-h-screen">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
      <Toaster theme="light" position="top-right" richColors />
    </div>
  );
}

export default App;
